import { QueryClient } from '@tanstack/react-query';
import { WaterlilyClient } from '@/api/waterlily';
import { IntegrationsClient } from '@/api/integrations';

// Token management for both clients
export function setAuthToken(token: string): void {
  WaterlilyClient.setToken(token);
  IntegrationsClient.setToken(token);
}

export function clearAuthToken(): void {
  WaterlilyClient.clearToken();
  IntegrationsClient.clearToken();
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 0, // Data is immediately stale, triggers refetch
      gcTime: 10 * 1000, // 10 seconds garbage collection
      refetchOnMount: true, // Refetch when component mounts
      refetchOnWindowFocus: false, // Optional: disable if you don't want this
    },
  },
});
